if (!customElements.get('bb-connection-offer')) {
  class BBConnectionOffer extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('[data-bb-connection-add]').forEach((button) => {
        button.addEventListener('click', () => this.addService(button), { once: true });
      });
    }

    async addService(button) {
      const status = this.querySelector('.bb-connection-offer__status');
      const initialLabel = button.querySelector('strong').textContent;

      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.querySelector('strong').textContent = 'Wird hinzugefügt…';
      status.textContent = '';

      try {
        const isDrawer = this.dataset.context === 'drawer';
        const sections = isDrawer
          ? ['cart-drawer', 'cart-icon-bubble']
          : ['main-cart-items', 'main-cart-footer', 'cart-icon-bubble', 'cart-live-region-text'];
        const response = await fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{
              id: Number(button.dataset.variantId),
              quantity: 1,
              properties: {
                'Anschluss für': button.dataset.parentTitle,
                _bb_service_parent_variant: button.dataset.parentVariantId
              }
            }],
            sections,
            sections_url: window.location.pathname
          })
        });
        const result = await response.json();

        if (!response.ok) throw new Error(result.description || 'Der Anschlussservice konnte nicht hinzugefügt werden.');

        if (isDrawer && document.querySelector('cart-drawer')) {
          document.querySelector('cart-drawer').renderContents(result, { openDrawer: true });
        } else {
          window.location.reload();
        }
      } catch (error) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.querySelector('strong').textContent = initialLabel;
        button.addEventListener('click', () => this.addService(button), { once: true });
        status.textContent = `${error.message} Bitte versuchen Sie es erneut.`;
      }
    }
  }

  customElements.define('bb-connection-offer', BBConnectionOffer);
}
